import axios from "axios";
import { useEffect, useState } from "react";
import { Badge, Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DatePicker from "../components/DatePicker";
import { useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { userSignal } from "../../../signal/userSignal";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { useNavigate, useSearchParams } from "react-router-dom";
import avatar1 from "../../../assets/images/avatars/01.png"
import pdfExport from "../../../assets/images/icons/pdf-export.svg"
import DataTable from "react-data-table-component";
import * as moment from "moment";
import "react-horizontal-strip-datepicker/dist/ReactHorizontalDatePicker.css";
import { tripSummmaryPDFGenerator } from "../../../utilities/excelGenerator";
import { dealerSignal } from "../../../signal/dealerSignal";
import Zoom from 'react-medium-image-zoom'
import ModalImage from "react-modal-image";
import eyeIcon from "../../../assets/images/icons/eye.svg"

export default function TripSummary() {
    
    const [userTrips, setUserTrips] = useState([])
    const [totalPresent, setTotalPresent] = useState(0)
    const [totalAbsent, setTotalAbsent] = useState(0)
    const [searchParams, setSearchParams] = useSearchParams();

    let date = searchParams.get("date");

    let today = new Date();

    if (date) {
        today = new Date(date)
    }

    const [selectedDate, setSelectedDate] = useState(today);

    const navigate = useNavigate();

    useEffect(() => {

    }, [])

    const getTrips = useQuery("trip-summary", async () => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/getAllTrips?startTime=${new Date(selectedDate).setHours(0, 0, 0, 0)}&endTime=${new Date(selectedDate).setHours(23, 59, 59, 59)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {

                let temp = {}
                for (let trip of data.data) {
                    temp[trip.userId] = trip
                }

                let usersWithTrips = []
                let usersWithoutTrips = []
                let totalPresent = 0
                let totalAbsent = 0
                let stateName = window.localStorage.getItem("state")

                Object.keys(allUsersSignal.value).forEach((key) => {
                    let user = allUsersSignal.value[key]
                    if(stateName && user?.state !== stateName){
                        return
                    }
                    let flag = false;
                    if (temp[user.id]) {
                        usersWithTrips.push({ ...temp[user.id], trip: true })
                        if (temp[user.id]?.isStarted && temp[user.id]?.isCompleted && temp[user.id]?.isNotEnded === false) {
                            flag = true
                        }
                    } else {
                        usersWithoutTrips.push({
                            userId: user.id,
                            trip: false
                        })
                    }

                    if (flag) {
                        totalPresent++;
                    } else {
                        totalAbsent++;
                    }
                })

                setUserTrips([...usersWithTrips, ...usersWithoutTrips])
                setTotalPresent(totalPresent)
                setTotalAbsent(totalAbsent)
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchTrips = () => {
        getTrips.refetch({ cancelRefetch: true });
    }

    useEffect(() => {
        refetchTrips();
    }, [selectedDate]);

    const onSelectedDay = (d) => {
        setSearchParams({ date: d });
        setSelectedDate(d);
    };

    const columns = [
        {
            name: "User",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/trips/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            <img
                                style={{ width: "20px", height: "20px" }}
                                src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                className="rounded-circle avatar-xs"
                                alt="friend"
                            />
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Status",
            center: true,
            selector: (row) => {

                if (row?.trip === false) {
                    return <Badge bg="secondary" text="white">Not Started</Badge>
                }

                if (!row?.isStarted) {
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="info" text="white">Scheduled</Badge>
                }
                else if (!row?.isCompleted) {
                    const isToday = moment(row?.startTime || row?.date).isSame(moment(), 'day');
                    if (!isToday) {
                        return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="danger" text="white">Not Ended</Badge>
                    }
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="warning" text="white">On Going</Badge>
                }
                else {
                    if (row?.isNotEnded) {
                        return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="danger" text="white">Not Ended</Badge>
                    }
                    return <Badge onClick={() => navigate(`/dashboard/trips/${row?.id}`)} bg="success" text="white">Completed</Badge>
                }
            }
        },
        {
            name: "Start Time",
            center: true,
            selector: "startTime",
            sortable: true,
            cell: (row) => {
                if (row?.isStarted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.startKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.startKM) > 0 && `${parseFloat(row?.startKM).toFixed(2)} km`}

                                {row?.startImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.startImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.startTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                return "-"

            }
        },
        {
            name: "End Time",
            center: true,
            selector: "endTime",
            sortable: true,
            cell: (row) => {
                if (row?.isCompleted) {
                    return <OverlayTrigger placement="top" overlay={
                        <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                            {`${parseFloat(row?.endKM).toFixed(2)} km`}
                        </Tooltip>}>


                        <span className="d-flex flex-column align-items-center" style={{ rowGap: "0.5rem" }}>

                            <span className="d-flex align-items-center">
                                {parseFloat(row?.endKM) > 0 && `${parseFloat(row?.endKM).toFixed(2)} km`}

                                {row?.endImage !== "" && <ModalImage
                                    showRotate={true}
                                    className="ms-2"
                                    hideDownload={true}
                                    small={eyeIcon}
                                    large={row?.endImage}
                                    alt="Start Image"
                                />}
                            </span>
                            <p className="m-0">{moment(row?.endTime).format("hh:mm A")}</p>
                        </span>
                    </OverlayTrigger>
                }
                else if (row?.trip !== false && moment().startOf('day').valueOf() !== row?.date) {
                    return row?.endTime ? moment(row?.endTime).format("hh:mm A") : "-";
                }
                return "-"

            }
        },
        {
            name: "Manual km",
            center: true,
            selector: "manualKM",
            cell: (row) => {
                if (row?.manualDistance) {
                    return `${parseFloat(row?.manualDistance / 1000).toFixed(2)} km`
                }
                return "-"
            },
            sortable: true,
        },
        {
            name: "Auto KM",
            center: true,
            selector: "autoCalculatedDistance",
            cell: (row) => {
                if (row?.autoCalculatedDistance) {
                    return `${parseFloat(row?.autoCalculatedDistance).toFixed(2)} km`
                }
                return "-"
            },
            sortable: true,
        },
        // {
        //     name: "New Customers",
        //     center: true,
        //     selector: (row) => {
        //         if (row?.trip === false) {
        //             return "-"
        //         }
        //         return row?.totalNewCustomers
        //     },
        //     sortable: true,
        // },
        {
            name: "DA",
            center: true,
            selector: "dailyAllowanceExpense",
            sortable: true,
            cell: (row) => {
                if (row?.trip === false) {
                    return "-"
                }
                return `${parseFloat(row?.dailyAllowanceExpense ? row?.dailyAllowanceExpense : 0).toFixed(2)} Rs`
            },
        },
        {
            name: "Expense",
            center: true,
            selector: "totalExpense",
            cell: (row) => {
                if (row?.trip === false) {
                    return "-"
                }
                return `${parseFloat(row?.totalExpense).toFixed(2)} Rs`
            },
            sortable: true,
        },
        {
            name: "Route",
            center: true,
            width: "400px",
            selector: "tasks",
            cell: (row) => {
                if (row?.trip === false) {
                    return "-"
                }
                if(row?.route && row?.route !== ""){
                    return row?.route
                }
                let str = ""

                let tasks = row?.tasks || []
                for (let i = 0; i < tasks?.length; i++) {
                    if (i === 0) {
                        if (tasks[i]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    } else {
                        if (str !== "") {
                            str += " -> "
                        }

                        if (tasks[i]?.destinationArea && tasks[i]?.destinationArea !== row?.tasks[i - 1]?.destinationArea) {
                            str += `${tasks[i]?.destinationArea}, `
                        }
                        if (tasks[i]?.destinationCity && tasks[i]?.destinationCity !== row?.tasks[i - 1]?.destinationCity) {
                            str += `${tasks[i]?.destinationCity}, `
                        }
                        if (tasks[i]?.destinationState && tasks[i]?.destinationState !== row?.tasks[i - 1]?.destinationState) {
                            str += `${tasks[i]?.destinationState}, `
                        }
                    }

                }
                return str
            }
        }
        // {
        //     name: "Tasks",
        //     center: true,
        //     selector: (row) => row?.tasks?.length,
        //     sortable: true,
        // },
        // {
        //     name: "Task Completed",
        //     center: true,
        //     selector: (row) => row?.tasksCompleted,
        //     sortable: true,
        // },
        // {
        //     name: "Action",
        //     center: true,
        //     selector: (row) => {
        //         return <Link to={`/dashboard/trips/${row?.id}`}>View</Link>
        //     }
        // }
    ]

    const taskColumns = [
        {
            name: "Title",
            selector: "title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.title}</Tooltip>}>
                    <span>{row?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "description",
            center: true,
            cell: (row) => {
                return row?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}>
                    <span>{row?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.status === "pending" ? <Badge bg="warning">{row?.status}</Badge> : <Badge bg="success">{row?.status}</Badge>
            },
            center: true,
        },
        {
            name: "Dealer",
            selector: "dealerId",
            cell: (row) => {
                if (dealerSignal?.value && dealerSignal?.value[row?.dealerId]) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{dealerSignal.value[row?.dealerId]?.name}</Tooltip>}>
                        <span>{dealerSignal.value[row?.dealerId]?.name}</span>
                    </OverlayTrigger>
                }
                return "-"
            },
            center: true
        },
        {
            name: "Remarks",
            selector: "remarks",
            center: true,
            cell: (row) => {
                return row?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remarks}</Tooltip>}>
                    <span>{row?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Completed Time",
            selector: (row) => {

                if (row?.completedAt === "" || row?.completedAt === null || row?.completedAt === undefined || row?.completedAt === 0) {
                    return "-"
                }
                return moment(row?.completedAt).format("hh:mm A")
            },
            center: true,
        },
        {
            name: "Address",
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{`${row?.destinationArea !== "" ? row?.destinationArea + ", " : ""}${row?.destinationCity !== "" ? row?.destinationCity + ", " : ""}${row?.destinationState !== "" ? row?.destinationState + ", " : ""}`}</Tooltip>}>
                    <span>{`${row?.destinationArea !== "" ? row?.destinationArea + ", " : ""}${row?.destinationCity !== "" ? row?.destinationCity + ", " : ""}${row?.destinationState !== "" ? row?.destinationState + ", " : ""}`}</span>
                </OverlayTrigger>
            },
            width: "300px",
            center: true,
        },
        {
            name: "Completed Location",
            selector: (row) => {
                if (row?.completedAtLocation?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.completedAtLocation[0]},${row?.completedAtLocation[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>
                }
                return "NA"
            },
            center: true,
        }
    ]

    const ExpandedComponent = ({ data }) => {
        return (
            <div>
                <DataTable
                    columns={taskColumns}
                    data={data?.tasks}
                    pagination={true}
                    paginationPerPage={35}
                />
            </div>
        );
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Trip Summary</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>

                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="w-75">
                                        <DatePicker
                                            getSelectedDay={onSelectedDay}
                                            labelFormat={"MMMM"}
                                            color={"#096DD9"}
                                            selectDate={selectedDate}
                                            enableDaysBefore={30}
                                        />
                                    </div>
                                </div>

                                <div className="mt-5" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "1rem", marginBottom: "1rem", columnGap: "1rem" }}>
                                    <div className="d-flex col-9" style={{ columnGap: "1rem" }}>
                                        <Card className="bg-soft-info col-3 p-0 mb-0" style={{ height: "60px" }}>
                                            <Card.Body className="py-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="bg-soft-info rounded p-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="text-end">
                                                        <h4 className="counter">{new Date(selectedDate).setHours(0, 0, 0, 0) > new Date(today).setHours(0, 0, 0, 0) ? "-" : parseInt(totalPresent)}</h4>
                                                        Total Present
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>

                                        <Card className="bg-soft-warning col-3 p-0 mb-0" style={{ height: "60px" }}>
                                            <Card.Body className="py-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="bg-soft-warning rounded p-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="text-end">
                                                        <h4 className="counter">{new Date(selectedDate).setHours(0, 0, 0, 0) > new Date(today).setHours(0, 0, 0, 0) ? "-" : parseInt(totalAbsent)}</h4>
                                                        Total Absent
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    <button className="btn btn-danger me-2 text-light" onClick={() => tripSummmaryPDFGenerator(userTrips, allUsersSignal.value, `Trip-Summary ${moment(selectedDate).format("DD/MM/YY")}`)} disabled={getTrips.isLoading || getTrips.isFetching}>
                                        <img src={pdfExport} style={{width: "25px", height: "25px", color: 'white'}} /> Export
                                    </button>
                                </div>

                                {(!getTrips.isLoading && !getTrips?.isFetching) && <DataTable
                                    columns={columns}
                                    data={userTrips}
                                    pagination={true}
                                    paginationPerPage={35}
                                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                    onRowClicked={(row) => navigate(`/dashboard/trips/${row?.id}`)}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                    customStyles={{
                                        rows: {
                                            style: {
                                                cursor: "pointer",
                                                backgroundColor: "unset"
                                            }
                                        }
                                    }}
                                />}
                                {(getTrips.isLoading || getTrips?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )

}